__turbopack_context__.v({
  "action-container": "buy-box-module-scss-module__Au7YHG__action-container",
  "action-container-body": "buy-box-module-scss-module__Au7YHG__action-container-body",
  "buttons-container": "buy-box-module-scss-module__Au7YHG__buttons-container",
  "buttons-container-collapsible": "buy-box-module-scss-module__Au7YHG__buttons-container-collapsible",
  "container": "buy-box-module-scss-module__Au7YHG__container",
  "course-includes": "buy-box-module-scss-module__Au7YHG__course-includes",
  "discount-deadline": "buy-box-module-scss-module__Au7YHG__discount-deadline",
  "discount-price": "buy-box-module-scss-module__Au7YHG__discount-price",
  "horizontal-buttons": "buy-box-module-scss-module__Au7YHG__horizontal-buttons",
  "list-price": "buy-box-module-scss-module__Au7YHG__list-price",
  "percent-discount": "buy-box-module-scss-module__Au7YHG__percent-discount",
  "price-container": "buy-box-module-scss-module__Au7YHG__price-container",
  "secondary-message": "buy-box-module-scss-module__Au7YHG__secondary-message",
  "ud-text-sm": "buy-box-module-scss-module__Au7YHG__ud-text-sm",
  "vertical-buttons": "buy-box-module-scss-module__Au7YHG__vertical-buttons",
});
